import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'; 
import Sidebar from './Layouts/Sidebar';
import './../Assets/CSS/Style.css';
import axios from 'axios';
import { BASE_URL } from './../Environment';
import { toast } from 'react-toastify';
 
function Page() {
    const { slug } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState([]);
    useEffect(() => {
        setIsLoading(true);
        axios.get(`${BASE_URL}/page/detail/${slug}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            document.title = `Infomart | ${res.data.data.name}`;
            setPage(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);
        });
    }, [slug]);
    return (
        <div className="app"> 
            <div className="outlet">
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ? <h5 className="text-center mt-5">Loading...</h5> : null}
                    <div className="px-5" dangerouslySetInnerHTML={{ __html: page.content }}></div>
                </div>
            </div>  
        </div>
    );
}

export default Page;  